import React from 'react';
import useLocalization from 'localization';
import withFocus from '../../hocs/withFocus';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
export const SkipToContent = ({ isFocused, handleFocus, handleBlur }) => {
    const { t } = useLocalization();
    const { colors, inputs: { base, shape, size, buttonStyles } } = useTheme();
    const margin = useComponentMargin({ margin: 'regular' });
    const wrapperStyles = {
        backgroundColor: colors.neutrals.background,
        position: 'absolute',
        top: 0,
        left: 0,
        textAlign: 'center',
        opacity: isFocused ? 1 : 0,
        zIndex: isFocused ? 9999 : -9999,
        ...shape.rounded
    };
    const styles = {
        display: 'inline-block',
        textDecoration: 'none',
        ...base,
        ...shape.pill,
        ...buttonStyles.variant.primary,
        ...size.regular,
        ...margin,
        backgroundColor: isFocused ? colors.brand.primary.alpha : colors.neutrals.background
    };
    return (React.createElement("span", { style: wrapperStyles },
        React.createElement("a", { href: "#main", onFocus: handleFocus, onBlur: handleBlur, style: styles }, t('Skip to content'))));
};
export default withFocus(SkipToContent);
//# sourceMappingURL=index.js.map